export const showLoaderCartButton =
  (cartButtons: NodeListOf<HTMLElement>) => (show: boolean) => {
    if (!cartButtons.length) {
      return;
    }
    if (show) {
      cartButtons.forEach((button) =>
        button.classList.toggle('store__buy-btn--is-loading', true)
      );
    } else {
      cartButtons.forEach((button) =>
        button.classList.toggle('store__buy-btn--is-loading', false)
      );
    }
  };
